<div class="permissions-fields">
  <form [formGroup]="form">
    <div class="form-row">
      <mat-form-field>
        <input
          formControlName="CompanySlug"
          type="text"
          [placeholder]="'components.dtmTab.customElevations.company' | translate"
          required
          matInput
          [matAutocomplete]="auto"
          autocomplete="off"
          [matAutocompleteDisabled]="isCompanyAdmin"
        >
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onCompanyChange($event)"
                          [displayWith]="displayCompanyProperty">
          <mat-option *ngFor="let company of filteredCompaniesData$ | async" [value]="company">
            {{ company.Name }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>

    <ng-container [ngTemplateOutlet]="descriptionFieldTemplateRef"></ng-container>

    <ng-container [ngTemplateOutlet]="nameFieldTemplateRef"></ng-container>

    <ng-container [ngTemplateOutlet]="slugFieldTemplateRef"></ng-container>

    <div class="form-row">
      <mat-form-field>
        <mat-icon class="help-tooltip"
                  *ngIf="isShowScopeTooltip"
                  [matTooltip]="getScopeTooltipText()">
          help_outline
        </mat-icon>
        <mat-select
          formControlName="Scope"
          required
          placeholder="{{ 'permissions.visibility' | translate }}"
        >
          <mat-option [value]="scopes.CompanyScope">
            {{ 'permissions.scope.company' | translate }}
          </mat-option>
          <mat-option [value]="scopes.TeamPublicScope">
            {{ 'permissions.scope.teamPublic' | translate }}
          </mat-option>
          <mat-option [value]="scopes.TeamPrivateScope"
                      [disabled]="isPrivateVisibilityDisabled">
            <span matTooltip="{{ 'permissions.privateDtmTooltipText' | translate }}">
              {{ 'permissions.scope.teamPrivate' | translate }}
            </span>
          </mat-option>
        </mat-select>
        <mat-error
          *ngIf="
            form.get('Scope').errors &&
            form.get('Scope').errors.required &&
            (form.get('Scope').dirty || form.get('Scope').touched)
          "
        >{{ 'validation.required' | translate: { name: ('permissions.Scope' | translate) } }}
        </mat-error>
      </mat-form-field>
    </div>

    <div class="warning-about-set-public" *ngIf="isShowWarningAboutSetPublic">
      <mat-icon class="icon">error_outline</mat-icon>
      <p class="text">{{ 'permissions.warningAboutSetPublic' | translate }}</p>
    </div>

    <ng-container *ngIf="isShowTeamField">
      <div class="form-row">
        <mat-form-field>
          <input
            formControlName="OwnerTeamId"
            type="text"
            [placeholder]="'components.dtmTab.customElevations.team' | translate"
            matInput
            required
            [matAutocomplete]="auto"
            autocomplete="off"
          />
          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onTeamChange($event)"
                            [displayWith]="displayTeamProperty">
            <mat-option *ngFor="let company of filteredTeamsData$ | async" [value]="company">
              {{ company.Name }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </ng-container>
  </form>
</div>
